import ApiService from "./apiservice";

export const GeoLocationService = {
    GetGeoLocation(data) {
        return ApiService.get("GeoLocation/GetGeoLocation", data);
    },
    AddGeoLocation(data) {
        return ApiService.post("GeoLocation/AddGeoLocation", data);
    },
    ModifyGeoLocation(data) {
        return ApiService.post("GeoLocation/ModifyGeoLocation", data);
    },
    DeleteGeoLocation(params) {
        return ApiService.get("GeoLocation/DeleteGeoLocation", params);
    },
    isValidLocation(data) {
        return ApiService.post("GeoLocation/isvalidlocation", data);
    },
    GetIoPageLocation(params) {
        return ApiService.get("GeoLocation/GetIoPageLocation", params);
    },
    GetLocationName(params) {
        return ApiService.get("GeoLocation/GetLocationName", params);
    },
    AddIoWithLocation(data) {
        return ApiService.post("AddIoWithLocation", data);
    },
    GetGeoLocationAllowedPersonels(params){
        return ApiService.get("GeoLocation/GetGeoLocationAllowedPersonels", params);
    },
    GetGeoLocationAllowedSections(params){
        return ApiService.get("GeoLocation/GetGeoLocationAllowedSections", params);
    }
};